



<template>
  <div>
    <div class="row mt-2">
      <div class="col-md-2">
        <label>Colaborador</label>
        <input
          type="text"
          class="form-control"
          v-model="filters.collaborator"
        />
      </div>

      <div class="col-md-2">
        <label>Centro de Custo</label>
        <input type="text" class="form-control" v-model="filters.bill_center" />
      </div>

      <div class="col-md-2">
        <label>Status</label>
        <select class="form-control" v-model="filters.status">
          <option :value="null">Selecione</option>
          <option v-for="s in statusOptions" :key="s.id" :value="s.id">
            {{ s.description }}
          </option>
        </select>
      </div>

      <div class="col-md-2">
        <label>Data</label>
        <input
          type="date"
          class="form-control"
          v-model="filters.date"
          placeholder="dd/mm/aaaa"
        />
      </div>

      <div class="col-md-4">
        <div class="form-group mb-2">
          <label>Item comprado</label>
          <input
            type="text"
            class="form-control"
            v-model="filters.product_name"
            placeholder="Nome do produto"
          />
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group mb-2">
          <label>Forma de pagamento</label>
          <select class="form-control" v-model="filters.payment_method">
            <option value="">Selecione</option>
            <option v-for="p in paymentOptions" :key="p.id" :value="p.id">
              {{ p.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group mb-2">
          <label>Data do pagamento</label>
          <input
            type="date"
            class="form-control"
            v-model="filters.payment_date"
          />
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-4 d-flex align-items-end">
        <button
          class="btn btn-primary mr-2"
          @click="
            currentPage = 1;
            getDasps();
          "
        >
          Filtrar
        </button>
        <button class="btn btn-secondary" @click="clearFilters">
          Limpar Filtros
        </button>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="card content-crud">
          <div class="ibox">
            <div class="ibox-title" style="padding: 16px">
              <div
                class="ibox-title d-flex align-items-center justify-content-between"
              >
                <h3 class="mb-0">DASP</h3>
                <button class="btn btn-primary" @click="goAdd">
                  Nova DASP
                </button>
              </div>
            </div>
            <div class="ibox-content">
              <div class="table-responsive" style="padding: 10px">
                <table
                  class="VueTables__table table table-striped table-bordered table-hover"
                  style="padding: 10px"
                >
                  <thead>
                    <tr>
                      <th scope="col">ID</th>
                      <th scope="col">COLABORADOR</th>
                      <th scope="col">CENTRO DE CUSTO</th>
                      <th scope="col">NÚMERO</th>
                      <th scope="col">TIPO</th>
                      <th scope="col">STATUS</th>
                      <th scope="col">DATA</th>
                      <th scope="col">VALOR PAGO</th>
                      <th scope="col">AÇÕES</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(d, idx) in dasps" :key="d.id">
                      <td>{{ d.id }}</td>
                      <td class="td-user">
                        {{
                          d.user_collaborator
                            ? d.user_collaborator.name
                            : "Não Informado"
                        }}
                      </td>
                      <td class="td-bc">
                        {{ d.bill_center ? d.bill_center : "" }}
                      </td>
                      <td>{{ d.number }}</td>
                      <td>
                        {{ isPurchaseNotice(d) ? "Aviso de Compra" : "Solicitação" }}
                      </td>
                      <td>
                        <span
                          class="badge"
                          :class="'badge-' + d.status_badge"
                          >{{ d.status_name }}</span
                        >
                      </td>
                      <td class="td-ca">{{ d.created_at_f }}</td>
                      <td class="td-value">
                        {{ calculateTotalPaid(d) }}
                      </td>
                      <td class="actions-cell">
                        <div class="action-grid">
                          <button
                            type="button"
                            class="icon-btn copy"
                            title="Duplicar"
                            @click="goDouble(d)"
                          >
                            <i class="fas fa-clone"></i>
                          </button>
                          <button
                            type="button"
                            class="icon-btn eye"
                            title="Ver"
                            @click="goView(d)"
                          >
                            <i class="fas fa-eye"></i>
                          </button>
                          <button
                            type="button"
                            class="icon-btn download"
                            title="Baixar PDF"
                            @click="download(d)"
                          >
                            <i class="fas fa-download"></i>
                          </button>
                          <button
                            type="button"
                            class="icon-btn trash"
                            title="Excluir"
                            @click="destroy(d, idx)"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center"
                >
                  <pagination
                    :records="total"
                    :options="options"
                    :per-page="15"
                    @paginate="getDasps"
                  ></pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import { Pagination } from "vue-pagination-2";
import { get } from "jquery";

export default {
  data: function () {
    return {
      filters: {
        collaborator: "",
        bill_center: "",
        status: null,
        date: "",
        product_name: "",
        payment_method: "",
        payment_date: "",
      },
      paymentOptions: [
        { id: 1, name: "Cartão de Crédito" },
        { id: 2, name: "Boleto" },
        { id: 3, name: "Pix" },
      ],
      statusOptions: [],
      dasps: [],
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      currentPage: 1,
      perPage: 10,
      lastPage: 1,
      saveTimeout: null, // Para debounce ao salvar filtros
    };
  },
  components: {
    BaseCrud,
    vSelect,
    Pagination,
  },

  methods: {
    // Salvar filtros no localStorage
    saveFilters() {
      const filtersToSave = {
        filters: this.filters,
        currentPage: this.currentPage,
      };
      localStorage.setItem('daspTableFilters', JSON.stringify(filtersToSave));
    },

    // Carregar filtros do localStorage
    loadFilters() {
      const saved = localStorage.getItem('daspTableFilters');
      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          if (parsed.filters) {
            this.filters = { ...this.filters, ...parsed.filters };
          }
          if (parsed.currentPage) {
            this.currentPage = parsed.currentPage;
          }
        } catch (e) {
          console.error('Erro ao carregar filtros salvos:', e);
        }
      }
    },

    async loadStatusOptions() {
      const url = this.$store.state.api + "dasp/status-options";
      const { data } = await axios.get(url);
      this.statusOptions = data;
    },

    goAdd() {
      if (this.$router?.resolve({ name: "DaspAdd" }).resolved.matched.length) {
        this.$router.push({ name: "DaspAdd" });
      } else {
        this.$router.push("/dasps/add");
      }
    },
    goView(dasp) {
      if (
        this.$router?.resolve({ name: "ViewDasp", params: { id: dasp.id } })
          .resolved.matched.length
      ) {
        this.$router.push({ name: "ViewDasp", params: { id: dasp.id } });
      } else {
        this.$router.push("/dasps/view/" + dasp.id);
      }
    },

    goDouble(dasp) {
      if (
        this.$router?.resolve({ name: "DaspDouble", params: { id: dasp.id } })
          .resolved.matched.length
      ) {
        this.$router.push({ name: "DaspDouble", params: { id: dasp.id } });
      } else {
        this.$router.push("/dasps/double/" + dasp.id);
      }
    },

    download(dasp) {
      // dasp.file já vem da API como URL assinada; montar a URL pelo ID resultaria em 403
      window.open(dasp.file, "_blank", "noopener");
    },

    async destroy(dasp, idx) {
      const url = `${this.$store.state.api}dasps/${dasp.id}`;

      const choice = await swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        icon: "warning",
        buttons: {
          cancel: {
            text: "Não",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "Sim",
            value: "confirm",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
      });

      if (choice !== "confirm" && choice !== true) {
        swal("Cancelado", "O registro não foi excluído!", "info");
        return;
      }

      try {
        await axios.delete(url);
      } catch (e) {
        const fd = new FormData();
        fd.append("_method", "DELETE");
        await axios.post(url, fd);
      }

      if (typeof idx === "number") this.dasps.splice(idx, 1);
      swal.close();
      swal("Sucesso", "Registro excluído com sucesso!", "success");
    },

    getDasps(page) {
      const self = this;

      self.page = page || self.currentPage || 1;
      self.currentPage = self.page;

      let api =
        self.$store.state.api +
        "dasp/dasps?page=" +
        self.page +
        "&with[]=dasp_products";

      self.$loading(true);
      axios
        .post(api, self.filters)
        .then((response) => {
          self.dasps = response.data.data;
          self.total = response.data.total;
          self.lastPage = response.data.last_page || Math.ceil(self.total / self.perPage);
          // Salvar filtros após cada busca bem-sucedida
          self.saveFilters();
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },

    goToPage(page) {
      if (page < 1) page = 1;
      if (this.lastPage && page > this.lastPage) page = this.lastPage;
      this.currentPage = page;
      this.getDasps();
    },

    clearFilters() {
      this.filters = {
        collaborator: "",
        bill_center: "",
        status: null,
        date: "",
        product_name: "",
        payment_method: "",
        payment_date: "",
      };
      this.currentPage = 1;
      // Limpar filtros salvos do localStorage
      localStorage.removeItem('daspTableFilters');
      this.getDasps();
    },

    toNumberBRL(value) {
      if (value === null || value === undefined || value === "") return 0;
      if (typeof value === "number") return value;

      // Remove R$, espaços, pontos (separador de milhar)
      // Mantém apenas dígitos, vírgula, sinal negativo e ponto decimal
      const cleaned = String(value)
        .replace(/R\$/g, "")
        .replace(/\s/g, "")
        .replace(/\./g, ""); // Remove pontos (separador de milhar: 1.000)

      // Troca vírgula por ponto (separador decimal: 654,95 -> 654.95)
      const normalized = cleaned.replace(",", ".");

      const n = Number(normalized);
      return isNaN(n) ? 0 : n;
    },

    isPurchaseNotice(dasp) {
      return !!(
        dasp.purchase_type &&
        dasp.purchase_type.name &&
        dasp.purchase_type.name.toLowerCase().includes("aviso de compra")
      );
    },
    calculateTotalPaid(dasp) {
      // Tenta usar dasp_products (plural) ou dasp_product (singular)
      const products = dasp.dasp_products || dasp.dasp_product;

      if (products && Array.isArray(products)) {
        let total = 0;

        products.forEach((product) => {
          total += this.toNumberBRL(product?.paid);
        });

        return total.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
      }

      // fallback: campo no cabeçalho da DASP
      if (dasp.paid) {
        const num = this.toNumberBRL(dasp.paid);
        return num.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
      }

      return "R$ 0,00";
    },
  },
  computed: {
    showingFrom() {
      if (!this.total) return 0;
      return (this.currentPage - 1) * this.perPage + 1;
    },
    showingTo() {
      return Math.min(this.currentPage * this.perPage, this.total);
    },
    pagesWindow() {
      const win = 6;
      const half = Math.floor(win / 2);
      let start = Math.max(1, this.currentPage - half);
      let end = Math.min(this.lastPage, start + win - 1);
      start = Math.max(1, end - win + 1);

      const out = [];
      for (let i = start; i <= end; i++) out.push(i);
      return out;
    },
  },

  watch: {
    // Salvar filtros automaticamente quando mudarem (com debounce)
    filters: {
      handler() {
        // Debounce para não salvar a cada tecla digitada
        if (this.saveTimeout) clearTimeout(this.saveTimeout);
        this.saveTimeout = setTimeout(() => {
          this.saveFilters();
        }, 500);
      },
      deep: true,
    },
  },

  mounted() {
    // Carregar filtros salvos antes de buscar os dados
    this.loadFilters();
    this.loadStatusOptions();
    // Buscar DASPs com os filtros carregados (se houver)
    this.getDasps(this.currentPage);
  },

  beforeDestroy() {
    // Limpar timeout ao destruir componente
    if (this.saveTimeout) clearTimeout(this.saveTimeout);
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}

.actions-cell {
  min-width: 96px;
}

.action-grid {
  display: grid;
  grid-template-columns: repeat(2, 22px);
  grid-auto-rows: 22px;
  gap: 6px;
  justify-content: end;
}

.icon-btn {
  width: 22px;
  height: 22px;
  border-radius: 5px;
  background: #fff;
  border: 1.25px solid #e6e6e6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  padding: 0;
  /* garante que fique pequeno */
  cursor: pointer;
}

.icon-btn i {
  font-size: 11px;
}

/* bordas coloridas */
.icon-btn.copy {
  border-color: #ff9800;
}

.icon-btn.eye {
  border-color: #ffc107;
}

.icon-btn.download {
  border-color: #2196f3;
}

.icon-btn.trash {
  border-color: #e91e63;
}

/* transição + cor do ícone herdada */
.icon-btn {
  color: #000;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.icon-btn i {
  color: inherit;
}

/* hovers: fundo = cor da borda, ícone branco */
.icon-btn.copy:hover {
  background: #ff9800;
  border-color: #ff9800;
  color: #fff;
}

.icon-btn.eye:hover {
  background: #ffc107;
  border-color: #ffc107;
  color: #fff;
}

.icon-btn.download:hover {
  background: #2196f3;
  border-color: #2196f3;
  color: #fff;
}

.icon-btn.trash:hover {
  background: #e91e63;
  border-color: #e91e63;
  color: #fff;
}

/* deixa a coluna mais estreita */
.td-bc {
  max-width: 220px;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 1.15;
}

.td-ca {
  min-width: 200px;
  line-height: 1.15;
}

.td-user {
  max-width: 200px;
  line-height: 1.15;
}

.pager-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 12px 0;
}

.pager-range {
  font-size: 0.9rem;
  opacity: 0.8;
}

.pager {
  display: flex;
  align-items: center;
  gap: 8px;
}

.page-btn {
  min-width: 36px;
  height: 32px;
  padding: 0 10px;
  border-radius: 16px;
  border: 1px solid #3b455e;
  background: #283046;
  color: #dbe2f2;
  cursor: pointer;
}

.page-btn:hover {
  background: #34405a;
}

.page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.page-btn.active {
  background: #1e75ff;
  border-color: #1e75ff;
  color: #fff;
  font-weight: 700;
}
</style>

